<h2 mat-dialog-title>{{ title }} · {{ data.clientName || 'Клиент №' + data.clientId }}</h2>
<mat-progress-bar *ngIf="loading || busy" mode="indeterminate"></mat-progress-bar>
<mat-dialog-content class="ca-dialog">
  <p class="ca-context">{{ data.orgName || 'Организация №' + data.orgId }} · суммы в гривнах</p>
  <div class="ca-mini-summary" *ngIf="summary">
    <span
      >Доступно <b>{{ summary.available_credit | number: '1.2-2' }}</b></span
    >
    <span
      >В заказах <b>{{ summary.committed_credit | number: '1.2-2' }}</b></span
    >
    <span
      >Долг <b>{{ summary.debt | number: '1.2-2' }}</b></span
    >
  </div>
  <p class="ca-note" *ngIf="data.kind === 'TOPUP'">
    Пополнение останется свободным. Заказы оплачиваются отдельным выбором менеджера.
  </p>
  <p class="ca-note" *ngIf="data.kind === 'PAYOUT'">
    Выплата доступных средств не закрывает долг по другим заказам.
  </p>
  <p class="ca-note" *ngIf="isConfirmation">
    Подтвердите фактическое поступление по банковской выписке. До подтверждения деньги недоступны
    для зачёта.
  </p>
  <p class="ca-note" *ngIf="isCancellation">
    Ожидающее пополнение будет отменено; подтверждённые деньги эта операция не списывает.
  </p>
  <form [formGroup]="form" class="ca-fields">
    <mat-form-field appearance="outline" *ngIf="requiresAmount"
      ><mat-label>Сумма, грн</mat-label
      ><input matInput type="number" min="0.01" step="0.01" formControlName="amount" /><mat-error
        >Введите сумму больше нуля</mat-error
      ></mat-form-field
    >
    <mat-form-field appearance="outline" *ngIf="isMoneyMovement"
      ><mat-label>Способ</mat-label
      ><mat-select formControlName="channel"
        ><mat-option value="CASH">Наличные</mat-option
        ><mat-option value="BANK">Безналичный перевод</mat-option></mat-select
      ></mat-form-field
    >
    <mat-form-field appearance="outline" *ngIf="isMoneyMovement && isCash"
      ><mat-label>Касса менеджера</mat-label
      ><mat-select formControlName="cashbox_id" (selectionChange)="contextError = ''"
        ><mat-option *ngFor="let channel of cashChannels" [value]="channel.bank_id">{{
          channel.label
        }}</mat-option></mat-select
      ></mat-form-field
    >
    <mat-form-field appearance="outline" *ngIf="isMoneyMovement && !isCash"
      ><mat-label>Банковский счёт организации</mat-label
      ><mat-select [value]="bankChannelKey" (selectionChange)="selectBankChannel($event.value)"
        ><mat-option
          *ngFor="let channel of bankChannels"
          [value]="channel.bank_id + ':' + (channel.org_bank_account_id || '')"
          >{{ channel.label }}</mat-option
        ></mat-select
      ><mat-hint *ngIf="!bankChannels.length"
        >Нет доступного связанного банковского счёта</mat-hint
      ></mat-form-field
    >
    <ng-container *ngIf="isConfirmation || (isMoneyMovement && !isCash)">
      <mat-form-field appearance="outline"
        ><mat-label>Основание / номер перевода</mat-label
        ><input matInput formControlName="bank_reference"
      /></mat-form-field>
      <mat-form-field appearance="outline"
        ><mat-label>Дата банковской операции</mat-label
        ><input
          matInput
          [matDatepicker]="bankDate"
          formControlName="bank_date" /><mat-datepicker-toggle
          matSuffix
          [for]="bankDate"
        ></mat-datepicker-toggle
        ><mat-datepicker #bankDate></mat-datepicker
      ></mat-form-field>
    </ng-container>
    <mat-form-field appearance="outline" class="ca-wide"
      ><mat-label>Комментарий / причина</mat-label
      ><textarea matInput rows="2" maxlength="500" formControlName="reason"></textarea>
    </mat-form-field>
  </form>
  <p class="ca-context" *ngIf="isMoneyMovement && isCash">{{ contextLabel }}</p>
  <p class="ca-error" role="alert" *ngIf="contextError">{{ contextError }}</p>
  <section *ngIf="isAllocation" class="ca-allocations">
    <div class="ca-section-title">Выберите счета и суммы зачёта</div>
    <div *ngFor="let invoice of invoices" class="ca-allocation-row">
      <a
        [routerLink]="['/docs/client_invoice/update', invoice.invoice_id]"
        target="_blank"
        rel="noopener"
        >Счёт №{{ invoice.invoice_id
        }}<small *ngIf="invoice.order_id"> · заказ №{{ invoice.order_id }}</small></a
      >
      <span>К оплате {{ invoice.due | number: '1.2-2' }}</span>
      <mat-form-field appearance="outline"
        ><mat-label>Зачесть</mat-label
        ><input
          matInput
          type="number"
          min="0"
          step="0.01"
          [max]="invoice.due"
          [value]="invoice.selectedAmount || ''"
          [disabled]="busy || uncertain"
          (input)="setAllocation(invoice, $any($event.target).value)"
      /></mat-form-field>
      <button
        mat-icon-button
        [disabled]="busy || uncertain"
        matTooltip="Заполнить доступной суммой"
        (click)="fillAllocation(invoice)"
      >
        <mat-icon>south</mat-icon>
      </button>
    </div>
    <p class="ca-note" *ngIf="!loading && !invoices.length">
      Открытых счетов этой организации нет. Создайте счёт в заказе и повторите зачёт.
    </p>
    <p class="ca-total">
      Всего к зачёту <b>{{ total | number: '1.2-2' }} грн</b>
    </p>
  </section>
  <section class="ca-preview" *ngIf="preview">
    <div class="ca-section-title">Результат операции</div>
    <div class="ca-preview-grid">
      <span></span><b>Сейчас</b><b>После</b> <span>Баланс</span
      ><b>{{ preview.before.balance | number: '1.2-2' }}</b
      ><b>{{ preview.after.balance | number: '1.2-2' }}</b> <span>Доступно</span
      ><b>{{ preview.before.available_credit | number: '1.2-2' }}</b
      ><b>{{ preview.after.available_credit | number: '1.2-2' }}</b> <span>В заказах</span
      ><b>{{ preview.before.committed_credit | number: '1.2-2' }}</b
      ><b>{{ preview.after.committed_credit | number: '1.2-2' }}</b> <span>Долг</span
      ><b>{{ preview.before.debt | number: '1.2-2' }}</b
      ><b>{{ preview.after.debt | number: '1.2-2' }}</b> <span>Ожидает банк</span
      ><b>{{ preview.before.pending_bank | number: '1.2-2' }}</b
      ><b>{{ preview.after.pending_bank | number: '1.2-2' }}</b>
    </div>
    <p class="ca-note" *ngIf="isAllocation">
      При погашении долга и уменьшении свободных средств общий баланс может не измениться.
    </p>
    <p class="ca-error" *ngFor="let reason of preview.blocked_reasons">{{ reason.message }}</p>
    <p class="ca-error" *ngIf="expired">Расчёт устарел. Рассчитайте операцию снова.</p>
  </section>
  <p class="ca-error" role="alert" *ngIf="error">{{ error }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button [disabled]="busy || uncertain" (click)="ref.close()">Отмена</button>
  <button mat-stroked-button [disabled]="!canPreview" (click)="calculate()">
    {{ preview ? 'Пересчитать' : 'Рассчитать' }}
  </button>
  <button
    mat-flat-button
    color="primary"
    [disabled]="busy || (!uncertain && !canExecute)"
    (click)="execute()"
  >
    {{ busy ? 'Выполнение…' : confirmLabel }}
  </button>
</mat-dialog-actions>
